export default "/fonts/Poppins-ExtraBold.ttf?2156e69bc095ee0ad41dce95d120b70d";